// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__d6VSa","btn":"styles_btn__2SKJL"};